// extracted by mini-css-extract-plugin
module.exports = {"buscar":"SerchBar_buscar__3Z8Mt","btn":"SerchBar_btn__c_C7R","input":"SerchBar_input__2LQDX"};